/** 富芮坤(freq) 机型：支持独立「灯效」页（light_mode / FreqLighting） */
const FREQ_LIGHTING_DEVICE_IDS = new Set([
  "a6",
  "a6pro",
  "a6max",
  "g2sea",
  "s7plus",
]);

export function freqDeviceSupportsLighting(deviceId?: string | null): boolean {
  const id = String(deviceId ?? "")
    .trim()
    .toLowerCase();
  return id ? FREQ_LIGHTING_DEVICE_IDS.has(id) : false;
}
